// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sp8c","content":"styles_content__26yYA"};